/* global amplitude */

// Triggers amplitude middleware registration.
import './amplitude/middleware.js';
import createStoreModule from './amplitude/createStoreModule';

const AMPLITUDE_EVENTS = {
    OFFERWEB_LANDING: 'Offerweb: landingpage',
    OFFERWEB_PRODUCT_SELECTOR: 'Offerweb: product-selector',
    OFFERWEB_PRODUCT_SELECTOR_INAPP_WINBACK: 'Offerweb: product-selector-inapp-winback',
    OFFERWEB_DOWNLOAD: 'Offerweb: download',
    OFFERWEB_PARTNER_CANALDIGITAL: 'Offerweb: Partner-Canal Digital',
    OFFERWEB_DEVICE_FLOW_LINK_CODE: 'Offerweb: link-code',
    OFFERWEB_DEVICE_FLOW_LINK_SUCCESSFUL: 'Offerweb: link-successful',
    OFFERWEB_VOUCHER_LANDING: 'Offerweb: voucher-landingpage',
    OFFERWEB_CAMPAIGN_LANDING: 'Offerweb: campaign-landingpage',
    OFFERWEB_CAMPAIGN_PRODUCT_SELECTOR: 'Offerweb: campaign-product-selector',
    LOGINWEB_CHECKUSER: 'Loginweb: checkuser',
    LOGINWEB_LOGGEDIN: 'Loginweb: loggedin',
    LOGINWEB_USER_CREATED: 'Loginweb: user-created',
    PAYMENTWEB_LANDING: 'Paymentweb: landing',
    PAYMENTWEB_PAYMENT_ADDED: 'Paymentweb: payment-added',
    PAYMENTWEB_SUBSCRIPTION_STARTED_PREMIUM: 'Paymentweb: subscription-started-Premium',
    PAYMENTWEB_SUBSCRIPTION_STARTED_HIFI: 'Paymentweb: subscription-started-Hifi',
    PAYMENTWEB_SUBSCRIPTION_STARTED: 'Paymentweb: subscription-started',
    PAYMENTWEB_EXISTING_PAYMENT_USED: 'Paymentweb: existing-payment-used',
    TIDAL_COM_LANDING: 'Tidalcom: landing-redirect-to-offerweb',
    TIDAL_COM_ABOUT: 'Tidalcom: about-redirect-to-offerweb',
    TIDAL_COM_LANDING_B: 'Tidalcom: landing-redirect-to-offerweb-alt-b',
};

/**
 * Exposes amplitude methods on `context.app.$amplitude` or `this.$amplitude`.
 */
export default function(ctx, inject) {
    ctx.store.registerModule('amplitude', createStoreModule(), {
        preserveState: Boolean(ctx.store.state.amplitude),
    });

    inject('amplitude', {
        sendEvent(userId, eventType, payload) {
            userId = userId || ctx.store.state.amplitude.userId;

            try {
                let eventMessage = '';
                if (AMPLITUDE_EVENTS[eventType]) {
                    eventMessage = AMPLITUDE_EVENTS[eventType];
                } else {
                    console.error(
                        `Tidal Aplitude Mixin Error: eventType ${eventType} not supported`);
                }
                if (window.amplitude && amplitude.amplitudeInitialize) {
                    if (amplitude.amplitudeInitialize === 'running') {
                        // if the status is running, attach the event listeners
                        window.addEventListener('amplitudeInitializeSuccess', function() {
                            if (userId) {
                                amplitude.getInstance().setUserId(userId);
                            }
                            return amplitude.getInstance().logEvent(
                                eventMessage, payload ? payload : {});
                        });
                        window.addEventListener('amplitudeInitializeFailed', function() {
                            return;
                        });
                    }
                    if (amplitude.amplitudeInitialize === 'failed') {
                        return;
                    } else if (amplitude.amplitudeInitialize === 'done') {
                        if (userId) {
                            amplitude.getInstance().setUserId(userId);
                        }
                        return amplitude.getInstance().logEvent(
                            eventMessage, payload ? payload : {});
                    }
                } else {
                    return;
                }
            } catch (e) {
                return;
            }
        },
        sendAmplitudeEventSync(userId, eventType, payload, cb) {
            userId = userId || ctx.store.state.amplitude.userId;

            try {
                let eventMessage = '';
                if (AMPLITUDE_EVENTS[eventType]) {
                    eventMessage = AMPLITUDE_EVENTS[eventType];
                } else {
                    console.error(
                        `Tidal Aplitude Mixin Error: eventType ${eventType} not supported`);
                }
                if (window.amplitude && amplitude.amplitudeInitialize) {
                    if (amplitude.amplitudeInitialize === 'running') {
                        // if the status is running, attach the event listeners
                        window.addEventListener('amplitudeInitializeSuccess', function() {
                            if (userId) {
                                amplitude.getInstance().setUserId(userId);
                            }
                            return amplitude.getInstance().logEvent(
                                eventMessage, payload ? payload : {}, cb);
                        });
                        window.addEventListener('amplitudeInitializeFailed', function() {
                            return cb();
                        });
                    }
                    if (amplitude.amplitudeInitialize === 'failed') {
                        return cb();
                    } else if (amplitude.amplitudeInitialize === 'done') {
                        if (userId) {
                            amplitude.getInstance().setUserId(userId);
                        }
                        return amplitude.getInstance().logEvent(
                            eventMessage, payload ? payload : {}, cb);
                    }
                } else {
                    return cb();
                }
            } catch (e) {
                return cb();
            }
        },
        getAmplitudeDeviceId() {
            try {
                if (window.amplitude && amplitude.amplitudeInitialize) {
                    if (amplitude.amplitudeInitialize === 'failed' ||
                        amplitude.amplitudeInitialize === 'running') {
                        return '';
                    } else if (amplitude.amplitudeInitialize === 'done') {
                        const instance = amplitude.getInstance();
                        let deviceId = '';
                        if (instance && instance.options) {
                            deviceId = instance.options.deviceId;
                        }
                        return deviceId;
                    }
                } else {
                    return '';
                }
            } catch (e) {
                return '';
            }
        },
        setUserId(userId) {
            ctx.store.commit('amplitude/setAmplitudeUserId', userId);
        },
    });
}
